/**
 * 关系图相关服务
 * Bai.Zhiming
 * 2019-4-17
 */
"use strict";
angular.module("hotARCServiceModule", []).
factory("hotARCService", [function() {
    /**
     * [countStr description] 计算字节数
     * @param  {[type]} str [description]
     * @return {[type]}     [description]
     */
    function countStr(str) {
        var count = 0;
        for (var i = 0; i < str.length; i++) { //str.length: 变量值的字符长度，值为6
            if (str.charCodeAt(i) > 255) {
                count += 2; //汉字编码大于255，一个汉字的字节为2
            } else {
                count++;
            }
        }
        return count;
    }
    return {
        /**
         * [textWrap description] 处理文字折行
         * @param  {[type]} optionData [description] 被处理的配置数据
         * @return {[type]}            [description]
         */
        textWrap: function(optionData) {
            optionData.forEach(function(item, index) {
                var theArray = [];
                var width = Math.sqrt(Math.pow(item.symbolSize / 2, 2) / 2) * 2; //正方形盒子的宽度
                var name = item.name;
                var theWidth = 0;
                var words = "";
                for (var i in name) {
                    var word = name[i];
                    var time = countStr(word);
                    theWidth += (time * 7);
                    words += word;
                    if (theWidth >= width) {
                        theArray.push(words);
                        word = "";
                        theWidth = 0;
                        words="";
                    } else if (theWidth < width && name.length - 1 == i) {
                        theArray.push(words);
                    }
                }
                item.label = {
                	formatter:theArray.join("\n")
                }
            });
            return optionData;
        }
    };
}]);